module.exports = __webpack_public_path__ + "media/images/landing_page/digweddash2-eaefb0e0eda298fe376ffa5d34c244dd.png";